import React from 'react';
var useStyles = _ref => {
  var {
    size = 32
  } = _ref;
  return React.useMemo(() => ({
    height: "".concat(size, "px")
  }), [size]);
};
export default useStyles;